import React from 'react';
import { Dialog } from '@mui/material';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import styles from '../../../refundStyles.module.scss';
import { useHistory } from "react-router-dom";
import { getReinitTimelineSteps } from "../constants";
import Timeline from '../Timeline';
import ALoader from 'views/pages/manage/common/a-loader';

const ReinitRefundDialog = ({ isOpen, updateRefund, loader }) => {
    const { psid, updatedOn, updatedBy } = updateRefund;
    const reinitTimelineSteps = getReinitTimelineSteps(updatedBy, updatedOn)
    const history = useHistory();
    return (
        <>
            {loader && <ALoader position="fixed" />}
            <Dialog
                open={isOpen}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "570px",
                        },
                    },
                }}>
                <div className={styles['reinit-refund-refund-dialog']}>
                    <div className={styles['header']}>Refund for PSID {psid} has been re-initiated</div>
                    <div className={styles['subHeader']}>Refund has been re-initiated and will be sent for approval once confirmed by the parents. Please check the dashboard for checking their status</div>
                    <Timeline steps={reinitTimelineSteps} />
                    <AButton
                        variant='primary_filled'
                        onClick={() => history.push('/admin/refundTracker')}
                        className={`no-ml-btn ${styles['dialog-btn']}`}
                    >
                        Okay
                    </AButton>
                </div>

            </Dialog>
        </>
    )
}

export default ReinitRefundDialog